import { ScoreCardMenu } from "@/components/ScoreCardMenu/ScoreCardMenu";
import { ScoreCardFragment } from "@/graphql/generated/graphql";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

const noop = () => {};

type MakeScoreCardOptions = {
  name: string;
  description: string;
};

function makeScoreCard(
  ID: string,
  { name, description }: MakeScoreCardOptions
): ScoreCardFragment {
  return {
    __typename: "ScoreCard",
    ID,
    name,
    description,
    createdAt: "2026-06-01T00:00:00.000Z",
    createdBy: "playground",
    isPublished: true,
    language: "en",
    categories: [],
  };
}

const SCORECARDS: ScoreCardFragment[] = [
  makeScoreCard("1", { name: "Mehmet Test", description: "Testing playbook" }),
  makeScoreCard("2", {
    name: "Marian Test (1 AI disabled question)",
    description: "",
  }),
  makeScoreCard("3", { name: "Test Daily", description: "Foo" }),
  makeScoreCard("4", { name: "Luis Test NA", description: "" }),
  makeScoreCard("5", {
    name: "Sales Test Nico",
    description: "Outbound sales call quality",
  }),
];

export function PlaygroundReviewScorecards() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Scorecard selector (panel / outline style)
        </PlaygroundSubSectionTitle>
        <div className="h-[420px] w-[420px]">
          <ScoreCardMenu data={SCORECARDS} onClickItem={noop} />
        </div>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
